import { render } from "./CardFixBinder.vue?vue&type=template&id=755f758e&scoped=true&ts=true"
import script from "./CardFixBinder.vue?vue&type=script&lang=ts"
export * from "./CardFixBinder.vue?vue&type=script&lang=ts"

import "./CardFixBinder.vue?vue&type=style&index=0&id=755f758e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755f758e"]])

export default __exports__